import React, { useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { Table } from "antd";
import { importantDocCols } from "./AllColumnsData";
import useModalHandlers from "../../hooks/useModalHandler";
import useGetAttributes from "../../hooks/useGetAttributes";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import useModuleData from "../../hooks/useFetchItems";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useUploadDocument from "../../hooks/useUploadDocument";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const MODULE_NAMES = [
  "Birth Certificate",
  "Social Security Cards",
  "Passport",
  "Driver License",
  "Marriage Certificate",
  "Military Records",
  "Living Will Important Document Storage",
  "Living Trust",
  "Power of Attorney Important Document Storage",
  "Insurance Policy",
  "Vehicle Titles Important Document Storage",
  "Educational Records",
  "Vaccination Records",
];


export default function ImportantDocumentStorage() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Important Document Storage");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const { fetchData, formatModuleKey, setTableData, setToUpdate, tableData } = useModuleData(
    MODULE_NAMES,
    setLoading
  );
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { attributes } = useGetAttributes(MODULE_NAMES, setLoading);
  const { deleteRecord } = useDeleteItem(fetchData, formatModuleKey, setTableData, setLoading);
  const { handleImageUpload } = useUploadDocument(setLoading, setFormData);

  const { showModal, updateModal, viewModal, handelCloseModal } = useModalHandlers(
    attributes,
    setModalTitle,
    setModuleName,
    setIsModalVisible,
    setFormData,
    setAttributesData
  );
  const columnsData = importantDocCols(viewModal, updateModal, deleteRecord);
  const AddDocument = () => {
    history.push("/organizer/important-document");
  };
  const collapseableTables = [
    { title: "Birth Certificate", key: 1 },
    { title: "Social Security Cards", key: 2 },
    { title: "Passport", key: 3 },
    { title: "Driver License", key: 4 },
    { title: "Marriage Certificate", key: 5 },
    { title: "Military Records", key: 6 },
    {
      title: "Living Will",
      originalTitle: "Living Will Important Document Storage",
      key: 7,
    },
    {
      title: "Living Trust",
      originalTitle: "Living Trust",
      key: 8,
    },
    {
      title: "Power Of Attorney",
      originalTitle: "Power Of Attorney Important Document Storage",
      key: 9,
    },
    { title: "Insurance Policy", key: 10 },
    {
      title: "Vehicle Titles",
      originalTitle: "Vehicle Titles Important Document Storage",
      key: 11,
    },
    { title: "Educational Records", key: 12 },
    { title: "Vaccination Records", key: 13 },
  ];
  
  // const columnsData=importantDocCols()
  const tableDataObj = {
    "Birth Certificate": tableData.birthCertificateData,
    "Social Security Cards": tableData.socialSecurityCardsData,
    Passport: tableData.passportData,
    "Driver License": tableData.driverLicenseData,
    "Marriage Certificate": tableData.marriageCertificateData,
    "Military Records": tableData.militaryRecordsData,
    "Living Will Important Document Storage": tableData.livingWillImportantDocumentStorageData,
    "Living Trust": tableData.livingTrustData,
    "Power Of Attorney Important Document Storage": tableData.powerOfAttorneyImportantDocumentStorageData,
    "Insurance Policy": tableData.insurancePolicyData,
    "Vehicle Titles Important Document Storage": tableData.vehicleTitlesImportantDocumentStorageData,
    "Educational Records": tableData.educationalRecordsData,
    "Vaccination Records": tableData.vaccinationRecordsData,
  };
  console.log("tableDatatableDatatableData",tableData,attributes,attributesData)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleItemsInfoSelect = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Important Documents Storage</h2>
        <ToolTipCreator name={"Disaster_Important_Document_Storage"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      {collapseableTables.map((table) => {
  const moduleTitle = table.originalTitle || table.title;
  return (
    <CollapseableTable
      title={table.title}
      key={table.key}
      onClick={() => showModal(moduleTitle)}
    >
      <Table
        columns={columnsData[moduleTitle]}
        dataSource={tableDataObj[moduleTitle]}
      />
    </CollapseableTable>
  );
})}
      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={handleImageUpload}
          loading={loading}
        />
      </div>
    </>
  );
}
